import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import TrainerDashboard from "@/pages/TrainerDashboard";
import ClientView from "@/pages/ClientView";
import DashboardRouter from "@/pages/DashboardRouter";
import { Toaster } from "@/components/ui/sonner";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/app" element={<ProtectedRoute><DashboardRouter /></ProtectedRoute>} />
            <Route path="/app/clients" element={<ProtectedRoute role="trainer"><TrainerDashboard /></ProtectedRoute>} />
            <Route path="/app/clients/:id" element={<ProtectedRoute><ClientView /></ProtectedRoute>} />
            <Route path="*" element={<Landing />} />
          </Routes>
          <Toaster richColors theme="dark" position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
